module.exports = __webpack_public_path__ + "media/duck.d1ddae53.mp3";